import React, { Component } from 'react';
import { weekDayAndHour, msToHour } from '../../../../lib/date.utils';
import ModalFull from '../../../helpers/ModalFull';
import StatesDetails from './StatesDetails';
import { getClearingForPartner } from '../../../../selectors/events/timetable';

class EntryDetails extends Component {
    componentDidMount() {
        document.addEventListener('keydown', this.handleKeyDown, false);
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.handleKeyDown, false);
    }

    handleKeyDown = (event) => {
        if (event.keyCode === 27 && this.props.open) {
            this.props.onClose();
        }
    };

    shouldComponentUpdate(nextProps) {
        return nextProps.entry !== this.props.entry || this.props.selectedPartner !== nextProps.selectedPartner;
    }
    _date = () =>
        weekDayAndHour(
            this.props.entry.day || this.props.entry.stageDate,
            msToHour(this.props.entry.start || this.props.entry.startHour),
            msToHour(this.props.entry.end || this.props.entry.endHour),
            true
        );
    render() {
        const { entry } = this.props;
        return (
            <ModalFull open={this.props.open} onClose={this.props.onClose}>
                {this.props.entry ? (
                    <div className="ckp-entry-details">
                        <div className="ckp-entry-details-title">
                            <h2 className="ckp-entry-details-artist">
                                {entry.artistName || (entry.Artist && entry.Artist.name) || ''}
                            </h2>
                            <h3 className="ckp-entry-details-date">{this._date()}</h3>
                            <h4 className="ckp-entry-details-stage ckp-ts-h4">
                                {entry.stageName || entry.stage || ''}
                            </h4>
                        </div>
                        <span className="ckp-modal-full-line" />
                        <StatesDetails clearing={getClearingForPartner(entry, this.props.selectedPartner)} setlist={entry.setlist} />
                        {/* <SocialInfo TODO-NT Deprecated?
                            photographer={this.props.entry.photographer}
                            socialMediaContact={this.props.entry.socialMediaContact}
                            pressContact={this.props.entry.pressContact}
                        /> */}
                        {/* <ArtistContact TODO-NT Deprecated? entry={this.props.entry} contact={this.props.contact} /> */}
                    </div>
                ) : null}
            </ModalFull>
        );
    }
}

export default EntryDetails;
